import { Helper } from '../Helper';
export class RefundAssetsHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        const references = sb.scope.addUnique();
        sb.emitSysCall(node, 'System.ExecutionEngine.GetScriptContainer');
        sb.emitSysCall(node, 'Neo.Transaction.GetReferences');
        sb.scope.set(sb, node, options, references);
        sb.emitSysCall(node, 'System.ExecutionEngine.GetScriptContainer');
        sb.emitSysCall(node, 'Neo.Transaction.GetInputs');
        sb.emitOp(node, 'NEWMAP');
        sb.emitHelper(node, options, sb.helpers.arrReduce({
            withIndex: true,
            each: (innerOptions) => {
                sb.emitOp(node, 'ROT');
                sb.scope.get(sb, node, innerOptions, references);
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'PICKITEM');
                sb.emitHelper(node, options, sb.helpers.if({
                    condition: () => {
                        sb.emitSysCall(node, 'Neo.Output.GetScriptHash');
                        sb.emitSysCall(node, 'System.ExecutionEngine.GetExecutingScriptHash');
                        sb.emitOp(node, 'EQUAL');
                    },
                    whenTrue: () => {
                        sb.emitOp(node, 'TUCK');
                        sb.emitOp(node, 'SWAP');
                        sb.emitSysCall(node, 'Neo.Input.GetHash');
                        sb.emitPushBoolean(node, true);
                        sb.emitOp(node, 'SETITEM');
                    },
                    whenFalse: () => {
                        sb.emitOp(node, 'NIP');
                    },
                }));
            },
        }));
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'DUP');
                sb.emitOp(node, 'ARRAYSIZE');
                sb.emitPushInt(node, 1);
                sb.emitOp(node, 'NUMEQUAL');
            },
            whenTrue: () => {
                sb.emitOp(node, 'KEYS');
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'PICKITEM');
                sb.emitOp(node, 'DUP');
                sb.emitHelper(node, options, sb.helpers.if({
                    condition: () => {
                        sb.emitHelper(node, options, sb.helpers.isProcessedTransaction);
                    },
                    whenTrue: () => {
                        sb.emitOp(node, 'DROP');
                        sb.emitPushBoolean(node, false);
                    },
                    whenFalse: () => {
                        sb.emitSysCall(node, 'Neo.Blockchain.GetTransaction');
                        sb.emitSysCall(node, 'Neo.Transaction.GetReferences');
                        sb.emitHelper(node, options, sb.helpers.arrEvery({
                            map: () => {
                                sb.emitSysCall(node, 'Neo.Output.GetScriptHash');
                                sb.emitHelper(node, options, sb.helpers.isCaller);
                            },
                        }));
                    },
                }));
            },
            whenFalse: () => {
                sb.emitOp(node, 'DROP');
                sb.emitPushBoolean(node, false);
            },
        }));
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
            },
            whenFalse: () => {
                sb.emitPushString(node, 'InvalidRefundAssetsError');
                sb.emitHelper(node, options, sb.helpers.wrapString);
                sb.emitHelper(node, options, sb.helpers.throw);
            },
        }));
        if (optionsIn.pushValue) {
            sb.emitHelper(node, options, sb.helpers.wrapUndefined);
        }
    }
}

//# sourceMappingURL=RefundAssetsHelper.js.map
